import StringConstants from './StringConstants';

const Constants = {
  ...StringConstants,
};

export default Constants;
